import * as z from "zod";
import { exportWeightedAudit } from "../onboardings/export-weighted-audit";

const timePeriodSchema = z.enum([
  "day",
  "week",
  "month",
  "last-month",
  "quarter",
  "all",
  "custom",
]);

const customRangeSchema = z.object({
  start: z.string().min(1),
  end: z.string().min(1),
});

export const getOnboardingsV2Audit = {
  name: "getOnboardingsV2Audit" as const,
  input: z
    .object({
      timePeriod: timePeriodSchema,
      customRange: customRangeSchema.optional(),
      searchQuery: z.string().optional(),
      hideArchived: z.boolean().default(true),
      auditMode: z.enum(["weighted", "fully-onboarded"]).default("weighted"),
      filterLowIntent: z.boolean().optional(),
    })
    .superRefine((value, ctx) => {
      if (value.timePeriod === "custom" && !value.customRange) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "customRange is required when timePeriod is custom",
          path: ["customRange"],
        });
      }
    }),
  output: exportWeightedAudit.output,
};

export type GetOnboardingsV2AuditInput = z.infer<
  typeof getOnboardingsV2Audit.input
>;
export type GetOnboardingsV2AuditOutput = z.infer<
  typeof getOnboardingsV2Audit.output
>;
